import { useState, useEffect } from 'react';
import api from '../utils/axios';

/**
 * Хук для получения номера последнего блока с сервера.
 */
const useCurrentBlock = () => {
	const [blockNumber, setBlockNumber] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchCurrentBlock = async () => {
			try {
				const response = await api.get('/current-block'); // Убедитесь, что путь к вашему API правильный
				setBlockNumber(response.data.block_number);
			} catch (err) {
				setError(err);
				console.error('Error fetching current block:', err);
			} finally {
				setLoading(false);
			}
		};

		fetchCurrentBlock();
	}, []);

	return { blockNumber, loading, error };
};

export default useCurrentBlock;
